import axios, { AxiosRequestConfig } from "axios";
import { ElMessage } from "element-plus";

const service = axios.create({
  baseURL:
    process.env.NODE_ENV == "development" || process.env.NODE_ENV == "stage"
      ? "https://camera.meierbei.cn/inference" // 测试
      : "https://camera.meierbei.cn/inference", // 正式
  timeout: 1000 * 120,
});

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.log("AI API ERROR:" + error);
    ElMessage.error("获取AI整形失败，请重试");
    return Promise.resolve(error);
  }
);

export default service;
